import React from 'react';
import { MainLayout, Triptych } from '@app/components';
import { useResourceScreenHelpers } from '@app/hooks';
import { loyaltyApi } from '@app/store';
import { ILoyalty } from '@app/common';
import { SettingHeader } from '@app/features/SettingHeader';
import { LoyaltyUpdate } from '@app/features/Loyalty';

export const LoyaltyScreen = () => {
  const { data: loyalty, isFetching } = loyaltyApi.useReadOneLoyaltiesQuery({});

  const { selectedItem } = useResourceScreenHelpers<ILoyalty>();

  return (
    <MainLayout
      header={<SettingHeader />}>
      <Triptych
        form={(
          <LoyaltyUpdate
            loyalty={loyalty ?? selectedItem}
            isFetching={isFetching} />
        )} />
    </MainLayout>
  );
};

